import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';
import { WaterfallChart } from '@/common/dashboard/charts/WaterfallChart';



export const FinanceDashboardWaterfallChart = ({
  startPeriod,
  endPeriod,
  periodicity,
  prodIds,
  channelIds,
  chartType,
  entity,
  hoveredCategory
}) => {
  const rsrc = useRsrc();
  const [data, setData] = useState();
  const selectedPeriod = hoveredCategory;


  useEffect(() => {
    if (!prodIds?.length) return;
    if (!channelIds?.length) return;

    const ndc11ProdIds = prodIds.map((prod) => prod);
    const reqParam = { selectedPeriod, startPeriod, endPeriod, periodicity, ndc11ProdIds, channelIds, entity };

    rsrc
      .data('gtn', 'PL_WATERFALL_DASHBOARD_DATA_PLUGIN', reqParam, entity)
      .then((rows) => setData(rows));
  }, [selectedPeriod, startPeriod, endPeriod, periodicity, prodIds, channelIds, entity]);

  if (!data) return null;


  // const colorMap = {
  //   Net: '#4caf50',
  //   Commercial: '#ffcdd2',        // light red
  //   'Managed Care (YD)': '#ef9a9a', // soft red
  //   ADAP: '#e57373',              // medium red
  //   Medicaid: '#f44336',          // classic red
  //   FSS: '#d32f2f',               // deep red
  //   PHS: '#b71c1c',               // darkest red
  //   'US Gross Sales': '#2196f3' // thin reference bar
  // };

  // --- Pivot data ---
  // function pivotData(data, valueKey = 'amt') {
  //   const map = new Map();
  //   data.forEach(({ period, channel, [valueKey]: value }) => {
  //     if (!map.has(period)) map.set(period, { period });
  //     map.get(period)[channel] = value;
  //   });
  //   return Array.from(map.values());
  // }

  // // --- Generate waterfall offset + step ---
  // function toWaterfallSeries(row, keys) {
  //   let result = [];
  //   let cumulative = 0;

  //   keys.forEach((key, i) => {
  //     const value = row[key] ?? 0;
  //     if (i === 0) {
  //       result.push({ label: key, offset: 0, step: value });
  //       cumulative = value;
  //     } else {
  //       result.push({ label: key, offset: cumulative - value, step: value });
  //       cumulative -= value;
  //     }
  //   });

  //   return result;
  // }

  // const pivotedData = pivotData(data);
  // // const firstRow = pivotedData[0];
  // const rowForPeriod =
  //   pivotedData.find((row) => row.period === period) ?? pivotedData[0];

  // // --- Add color to each step ---
  // const waterfallSeries = toWaterfallSeries(rowForPeriod, rawSeriesKeys).map((d) => ({
  //   ...d,
  //   stepFill: colorMap[d.label] || '#888888',
  // }));

  return (
    <WaterfallChart
          data={data.series}
          horizontal={false}
          dataLabels={true}
        />
  );
};
